import { useState } from "react";

const CATEGORIES = [
  {
    icon: "😀",
    emojis: [
      "😀","😃","😄","😁","😆","😅","😂","🤣","😊","😇",
      "🙂","😉","😍","🥰","😘","😗","😋","😛","🤪","🤨",
      "🧐","🤓","😎","🥳","😏","😒","😞","😔","😟","😕",
      "🙁","😣","😖","😫","😩","🥺","😢","😭","😤","😠",
      "😡","🤬","🤯","😳","🥵","🥶","😱","😨","😰","😥",
      "😓","🤗","🤔","🤭","🤫","🤥","😶","😐","😑","😬",
      "🙄","😯","😦","😧","😮","😲","🥱","😴","🤤","😪",
      "😵","🤐","🥴","🤢","🤮","🤧","😷","🤒","🤕","🤑",
      "🤠","😈","👿","👹","👻","💀","☠️","👽","🤖","🎃",
    ],
  },
  {
    icon: "👋",
    emojis: [
      "👋","🤚","🖐️","✋","🖖","👌","🤌","🤏","✌️","🤞",
      "🤟","🤘","🤙","👈","👉","👆","👇","☝️","👍","👎",
      "✊","👊","🤛","🤜","👏","🙌","👐","🤲","🤝","🙏",
      "✍️","💪","🦾","🦵","🦶","👂","👃","👀","👁️","👄",
      "💋","🧠","🫀","🫁","🦷","🦴","👶","🧒","👦","👧",
      "🧑","👨","👩","🧔","👱","👴","👵","🙍","🙎","🙅",
      "🙆","💁","🙋","🙇","🤦","🤷","👮","🕵️","💂","👷",
      "🤴","👸","👳","👲","🧕","🤵","👰","🤰","🤱","👼",
    ],
  },
  {
    icon: "❤️",
    emojis: [
      "❤️","🧡","💛","💚","💙","💜","🖤","🤍","🤎","💔",
      "❣️","💕","💞","💓","💗","💖","💘","💝","💟","♥️",
      "💌","💋","👄","🫦","🫂","💑","💏","💐","💍","💎",
      "🌹","🌷","🌸","💮","🏵️","🌺","🌻","🌼","🌞","🌝",
    ],
  },
  {
    icon: "🐶",
    emojis: [
      "🐶","🐱","🐭","🐹","🐰","🦊","🐻","🐼","🐨","🐯",
      "🦁","🐮","🐷","🐸","🐵","🙈","🙉","🙊","🐔","🐧",
      "🐦","🐤","🦆","🦅","🦉","🦇","🐺","🐗","🐴","🦄",
      "🐝","🐛","🦋","🐌","🐞","🐢","🐍","🦎","🐙","🦑",
      "🦐","🦀","🐠","🐟","🐬","🐳","🐋","🦈","🐊","🦓",
    ],
  },
  {
    icon: "🎉",
    emojis: [
      "🎉","🎊","🎈","🎁","🎀","🎗️","🎟️","🎫","🎪","🎭",
      "🎨","🎬","🎤","🎧","🎼","🎵","🎶","🥳","🍾","🥂",
      "🍻","🍷","🥃","🍸","🍹","🍺","🎯","🎮","🕹️","🎲",
      "🎰","🎳","🎸","🎹","🎺","🎻","🥁","🪘","🎷","🎙️",
      "📸","📷","🎥","📹","🌠","🎆","🎇","✨","💫","⭐",
    ],
  },
  {
    icon: "🍕",
    emojis: [
      "🍕","🍔","🍟","🌭","🥪","🌮","🌯","🥙","🍜","🍝",
      "🍣","🍱","🍚","🍛","🍤","🍢","🥟","🍦","🍧","🍨",
      "🍩","🍪","🎂","🍰","🧁","🥧","🍫","🍬","🍭","🍮",
      "🍯","🥛","☕","🍵","🧋","🥤","🧃","🍶","🍷","🍸",
      "🍹","🍺","🍻","🥂","🍾","🥃","🍴","🥄","🔪","🥢",
    ],
  },
  {
    icon: "✨",
    emojis: [
      "✨","💫","⭐","🌟","💥","💢","💤","💦","💨","🕳️",
      "💬","💭","🗯️","♨️","💈","💯","✅","❌","⭕","🚫",
      "⚠️","📛","🔴","🟠","🟡","🟢","🔵","🟣","⚫","⚪",
      "🟤","🔺","🔻","🔶","🔷","🔸","🔹","💠","🔘","⚡",
      "🔥","💧","🌊","🌈","☂️","☔","🌙","☀️","⛅","❄️",
    ],
  },
];

export default function EmojiPanel({ onEmoji, onBackspace }) {
  const [categoryIndex, setCategoryIndex] = useState(0);
  const category = CATEGORIES[categoryIndex];

  return (
    <div className="h-[300px] bg-white border-t border-[#E7E5E0] flex flex-col">
      {/* Category tabs */}
      <div className="h-11 flex items-center overflow-x-auto border-b border-[#E7E5E0] px-2 gap-1 flex-shrink-0">
        {CATEGORIES.map((c, i) => (
          <button
            key={i}
            onClick={() => setCategoryIndex(i)}
            className={`w-10 h-8 rounded-lg flex items-center justify-center text-lg flex-shrink-0 transition-colors ${
              i === categoryIndex
                ? "bg-[#F3E8FF]"
                : "hover:bg-[#F5F3EE]"
            }`}
          >
            {c.icon}
          </button>
        ))}
        <div className="ml-auto flex-shrink-0 pl-1">
          <button
            onClick={onBackspace}
            className="w-10 h-8 rounded-lg flex items-center justify-center hover:bg-[#F5F3EE] text-[#6B6B70]"
            title="Backspace"
          >
            ⌫
          </button>
        </div>
      </div>

      {/* Emoji grid */}
      <div className="flex-1 overflow-y-auto grid grid-cols-8 gap-0 px-2 py-2">
        {category.emojis.map((e, i) => (
          <button
            key={i}
            onClick={() => onEmoji(e)}
            className="aspect-square flex items-center justify-center text-2xl rounded-lg hover:bg-[#F5F3EE] transition-colors"
          >
            {e}
          </button>
        ))}
      </div>
    </div>
  );
}